import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import MFCWLResults from "@/components/MFCWLResults";

export default function MFCWLTestPage() {
  const { id } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.getSoundDetail(id)
      .then(r => setResult(r.data))
      .catch(console.error);
  }, [id]);

  if (!result) return <div className="p-8 text-center text-slate-400">Loading...</div>;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-3xl font-bold tracking-tight uppercase font-['Barlow'] text-slate-900">
          MFCWL Inspection Report
        </h1>
        <p className="text-sm text-slate-500">
          {result.car_details?.make} {result.car_details?.model} ({result.car_details?.year}) — {result.car_details?.km_driven?.toLocaleString()} km
        </p>
      </div>
      <MFCWLResults result={result} />
    </div>
  );
}
